import React from 'react';

export const TileIcon = ({ source, className = 'tile__location-icon', ...props }) => (
  <img className={className} src={source} alt={props.alt} {...props} />
);
